import { Injectable } from "@angular/core";
import { EntityActions } from "@app/entity/store/actions";
import { AlulaDealer } from "@app/project/model/alula-dealer";
import { State } from "@app/root-store/app.state";
import { AlulaDatabaseService, AlulaResponseData } from "@app/shared/databases/alula.database";
import { UserActions } from "@app/user/store/actions";
import { Action, Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class AlulaDealerService {
    dealerEndpoint = "dealers";
    createAlulaDealer(dealer: AlulaDealer): Observable<any> {
        return this.alulaDatabaseService.createAlulaDealer$({
            companyName: dealer.companyName,
            email: dealer.email,
            username: dealer.companyName.replace(/[^A-Z0-9]/gi, ""),
            uType: 8,
            nameFirst: dealer.firstName.replace(/[^A-Z]/gi, ""),
            nameLast: dealer.lastName.replace(/[^A-Z]/gi, ""),
            stationBilling: true,
        });
    }

    getAlulaDealer(dealerId: string): Observable<any> {
        return this.alulaDatabaseService
            .getRecord$(this.dealerEndpoint, dealerId)
            .pipe(map((dealer: AlulaResponseData) => AlulaDealer.fromDbObject(dealer)));
    }

    dispatchAction(action: EntityActions.EntityAction | UserActions.UserAction | Action) {
        this.store.dispatch(action);
    }

    constructor(private alulaDatabaseService: AlulaDatabaseService, private readonly store: Store<State>) {}
}
